import { translateField } from "@cdv/jazz-i18n";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";

export default function PersonalData(): ReactElement {
  const sx = { fontSize: "11px", color: "#00000099", mt: "15px" };
  return (
    <>
      <AppBar title={translateField(Resource.Info, "personal-data")} />

      <Card sx={{ mx: "16px", mt: "0 !important", borderRadius: 0, boxShadow: "none" }}>
        <CardContent sx={{ mt: 0 }}>
          <Typography variant="h5" sx={{ textAlign: "center", fontSize: "20px" }}>
            Podmínky použití aplikace StressOff
          </Typography>

          <Typography sx={sx}>
            <strong>1. Základní ustanovení</strong>
          </Typography>

          <Typography sx={sx}>
            Tyto Podmínky použití upravují používání webové aplikace StressOff (dále jen
            „Aplikace“). Aplikace je určena zejména řidičům, strojvedoucím a dalším zaměstnancům
            dopravních společností. Je nabízena především zaměstnavatelům a organizacím, které ji
            mohou zpřístupnit svým zaměstnancům. Přístup k Aplikaci si může zakoupit také
            jednotlivec pro vlastní potřebu.{" "}
          </Typography>

          <Typography sx={sx}>
            <strong>Aplikace obsahuje zejména:</strong>
          </Typography>

          <Typography sx={sx}>
            <ul>
              <li>informace a vzdělávací obsah o stresu,</li>
              <li>doporučení a praktické tipy pro prevenci a zvládání stresu,</li>
              <li>relaxační nahrávky,</li>
              <li>protistresové hry a další interaktivní prvky.</li>
            </ul>
          </Typography>

          <Typography sx={sx}>
            Používáním Aplikace uživatel potvrzuje, že se s těmito Podmínkami seznámil a souhlasí s
            nimi.
          </Typography>

          <Typography sx={sx}>
            <strong>2. Účel Aplikace</strong>
          </Typography>

          <Typography sx={sx}>
            Aplikace slouží jako podpůrný nástroj pro prevenci stresu a podporu duševní pohody.
            Poskytuje obecné informace, doporučení a praktická cvičení pro každodenní používání.
            Aplikace nenahrazuje lékařskou, psychologickou ani psychoterapeutickou péči a její obsah
            nepředstavuje zdravotní diagnózu ani individuální léčebné doporučení. Při závažných nebo
            dlouhodobých psychických či zdravotních obtížích je vhodné vyhledat odbornou pomoc.
          </Typography>

          <Typography sx={sx}>3. Bezpečné používání Aplikace</Typography>

          <Typography sx={sx}>
            Aplikaci není dovoleno používat během řízení vozidla, vedení drážního vozidla ani při
            výkonu jiné činnosti, která vyžaduje plnou pozornost. Toto omezení se vztahuje na
            veškerý obsah Aplikace, včetně vzdělávacích materiálů, relaxačních nahrávek, her,
            cvičení a dalších funkcí. Aplikaci používejte pouze v bezpečné situaci a na místě, kde
            její používání nemůže ohrozit vás ani jiné osoby. Uživatel je povinen používat Aplikaci
            v souladu s právními předpisy a těmito Podmínkami.
          </Typography>

          <Typography sx={sx}>
            <strong>4. Placený přístup</strong>
          </Typography>

          <Typography sx={sx}>
            Aplikace je poskytována jako placená služba. Aplikaci může zakoupit zaměstnavatel pro
            své zaměstnance nebo jednotlivec pro vlastní potřebu. Cena, rozsah služby, počet
            uživatelů a délka přístupu jsou uvedeny v nabídce, objednávce nebo smlouvě. Přístup k
            placenému obsahu je umožněn po řádném uhrazení ceny a po dobu odpovídající zakoupenému
            nebo sjednanému přístupu. Pokud Aplikaci zajišťuje zaměstnavatel, řídí se rozsah
            přístupu zaměstnanců podmínkami sjednanými mezi zaměstnavatelem a provozovatelem.
          </Typography>

          <Typography sx={sx}>
            <strong>5. Ochrana soukromí</strong>
          </Typography>

          <Typography sx={sx}>
            Používání Aplikace může být spojeno se zpracováním osobních údajů. Informace o
            zpracování osobních údajů a právech uživatelů jsou uvedeny v samostatné části těchto
            podmínek – Informace o zpracování osobních údajů (GDPR). Pokud Aplikaci hradí nebo
            zajišťuje zaměstnavatel, neznamená to automaticky, že má přístup k individuálním údajům
            uživatele nebo k informacím o jeho používání Aplikace. Rozsah případného zpracování
            osobních údajů se řídí pravidly uvedenými v části GDPR.
          </Typography>

          <Typography sx={sx}>
            <strong>6. Autorská práva</strong>
          </Typography>

          <Typography sx={sx}>
            Veškerý obsah Aplikace, zejména texty, grafika, nahrávky, hry a další materiály, je
            chráněn autorskými právy a dalšími právními předpisy. Bez souhlasu provozovatele není
            dovoleno obsah Aplikace kopírovat, veřejně šířit, poskytovat třetím osobám, upravovat
            ani využívat ke komerčním účelům.
          </Typography>

          <Typography sx={sx}>
            <strong>7. Dostupnost a odpovědnost</strong>
          </Typography>

          <Typography sx={sx}>
            Provozovatel se snaží zajistit dostupnost Aplikace v co nejvyšší možné míře. Nemůže však
            zaručit její nepřetržitou dostupnost, zejména z důvodu údržby, aktualizací, technických
            výpadků nebo jiných okolností mimo jeho kontrolu. Výsledný přínos Aplikace závisí také
            na způsobu a četnosti jejího používání a na individuální situaci uživatele. Provozovatel
            neodpovídá za újmu vzniklou používáním Aplikace v rozporu s těmito Podmínkami, zejména
            při jejím používání během řízení vozidla, vedení drážního vozidla nebo při jiné činnosti
            vyžadující plnou pozornost.
          </Typography>

          <Typography sx={sx}>
            <strong>8. Závěrečná ustanovení</strong>
          </Typography>

          <Typography sx={sx}>
            Provozovatel může Aplikaci průběžně aktualizovat, upravovat a doplňovat. Může také
            přiměřeně měnit tyto Podmínky, zejména v souvislosti s rozvojem Aplikace nebo změnou
            právních předpisů. Aktuální znění Podmínek je dostupné v Aplikaci.
          </Typography>

          <Typography sx={sx}>
            Tyto Podmínky se řídí právním řádem České republiky. <br />
            Účinnost od: 1.9.2026
          </Typography>

          <Typography sx={sx}>
            Provozovatel: <br />
            Centrum dopravního výzkumu, v. v. i. Líšeňská 33a, 636 00 Brno
            <br />
            IČ: 44994575
            <br />
            DIČ: CZ44994575
            <br />
          </Typography>

          <Typography variant="h5" sx={{ textAlign: "center", fontSize: "20px" }}>
            Ochrana vašich osobních údajů
          </Typography>

          <Typography sx={sx}>
            Vaše soukromí je naší prioritou. Níže najdete stručné informace o tom, jaké údaje v
            aplikaci zpracová váme, proč je potřebujeme a jaká máte práva.
          </Typography>

          <Typography sx={sx}>
            <strong>Kdo vaše údaje zpracovává?</strong>
            <br />
            <strong>Správce osobních údajů:</strong>
            <br />
            Centrum dopravního výzkumu, v. v. i.
            <br />
            Líšeňská 33a, 636 00 Brno
            <br />
            IČ: 44994575
            <br />
            DIČ: CZ44994575
            <br />
            Kontaktní e-mail: <a href="mailto:podatelna@cdv.gov.cz">podatelna@cdv.gov.cz</a>
            <br />
            Pověřenec pro ochranu osobních údajů (DPO):
            <br />
            E-mail: <a href="mailto:gdpr@cdv.gov.cz">gdpr@cdv.gov.cz</a>
            <br />
            <br />
            <strong>Jaké údaje zpracováváme?</strong>
            <br />
            V souvislosti s používáním aplikace můžeme zpracovávat:
            <br />
            Údaje k vašemu účtu: e-mailovou adresu, uživatelské jméno, heslo v zabezpečené podobě.
            <br />
            Technické údaje: IP adresu, údaje o zařízení a operačním systému, verzi aplikace, čas
            přístupů a technické záznamy o používání aplikace.
            <br />
            Údaje o stresu a psychické pohodě: vaše subjektivní hodnocení stresu a únavy, odpovědi v
            dotaznících, informace o absolvovaných cvičeních, údaje o vývoji vašich výsledků. Tyto
            údaje mohou představovat údaje o zdravotním stavu, tedy zvláštní kategorii osobních
            údajů podle GDPR.
            <br />
            <br />
            <strong>Proč údaje potřebujeme?</strong>
            <br />
            Údaje používáme zejména k tomu, abychom mohli vytvořit a spravovat váš uživatelský účet,
            zajistit bezpečný a správný chod aplikace, vyhodnocovat míru vaší psychické zátěže,
            přizpůsobovat doporučení a cvičení vašim potřebám, plnit zákonné povinnosti a chránit
            naše právní nároky.
            <br />
            <br />
            <strong>Údaje o vašem zdravotním stavu</strong>
            <br />
            Zpracování údajů o vašem zdravotním stavu probíhá na základě vašeho výslovného souhlasu.
            Souhlas je dobrovolný a můžete jej kdykoliv odvolat přímo v nastavení aplikace nebo
            kontaktováním správce. Odvoláním souhlasu není dotčena zákonnost zpracování, které
            proběhlo před jeho odvoláním.
            <br />
            <br />
            <strong>Aplikace není zdravotnickým prostředkem</strong>
            <br />
            Aplikace neposkytuje zdravotní služby. Její výstupy mají preventivní a edukační
            charakter a nenahrazují odbornou zdravotní péči.
            <br />
            <br />
            <strong>Bezpečnost při používání</strong>
            <br />
            Aplikaci nepoužívejte během řízení motorového vozidla. Pokud řídíte, věnujte se řízení a
            aplikaci použijte až po bezpečném zastavení.
            <br />
            <br />
            <strong>Kdo může mít k údajům přístup?</strong>
            <br />
            Vaše údaje jsou důvěrné. V nezbytném rozsahu mohou být zpracovávány také našimi
            ověřenými poskytovateli služeb, například: poskytovateli serverových, cloudových a IT
            služeb, dodavateli vývoje, údržby a zabezpečení aplikace, poskytovateli právních,
            auditorských a účetních služeb. Osobní údaje nepředáváme do zemí mimo Evropský
            hospodářský prostor (EHP) ani mezinárodním organizacím.
            <br />
            <br />
            <strong>Jak dlouho údaje uchováváme?</strong>
            <br />
            Údaje spojené s vaším účtem uchováváme po dobu jeho používání. Pokud účet zůstane
            neaktivní déle než 24 měsíců, bude účet a související údaje trvale anonymizován nebo
            vymazán. Údaje o zdravotním stavu zpracováváme do odvolání vašeho souhlasu nebo do
            zrušení účtu. Některé údaje můžeme uchovávat déle, pokud nám to ukládá zákon nebo je to
            nezbytné pro ochranu právních nároků.
            <br />
            <br />
            <strong>Jaká máte práva?</strong>
            <br />
            Podle GDPR máte zejména právo: získat přístup ke svým osobním údajům, opravit nepřesné
            nebo neúplné údaje, požádat o výmaz osobních údajů, požádat o omezení zpracování, získat
            své údaje ve strukturovaném formátu a požádat o jejich přenos, vznést námitku proti
            některým způsobům zpracování, kdykoliv odvolat souhlas se zpracováním údajů o zdravotním
            stavu, podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu osobních údajů
            Pplk. Sochora 27, 170 00 Praha 7, Web: www.uoou.cz
            <br />
            Svá práva můžete uplatnit na adrese sídla správce nebo e-mailem na podatelna@cdv.gov.cz
            či u pověřence pro ochranu osobních údajů na gdpr@cdv.gov.cz.
            <br />
            Na základě vašich osobních údajů nedochází k automatizovanému rozhodování s právními
            účinky ani k profilování ve smyslu čl. 22 GDPR.
          </Typography>
        </CardContent>
      </Card>

      <Box sx={{ textAlign: "center", mt: "10px" }}>
        <Button
          variant="contained"
          color="warning"
          size="large"
          onClick={() => window.history.back()}
        >
          OK
        </Button>
      </Box>
    </>
  );
}
